import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";
import * as Urls from "src/Constants/Urls";

const setCurrentPage = (pageIndex: number) =>
  store.dispatch(appActions.setCurrentPage(pageIndex));

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "personAndLasers",
    iconColor: "white",
    text: "Amplify human \npotential",
    listItemCustomStyle: { width: "195px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "personWithSunInside",
    iconColor: "white",
    text: "Reimagining \nuser personas",
    listItemCustomStyle: { width: "175px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "chipWithCheckmarkSquare",
    iconColor: "white",
    text: "Providing solutions \npowered by Generative AI",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const data = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  styleLeftPanel: { paddingRight: 0 },
  title: "AI First for Communications, \nMedia and Technology",
  text: "Learn how Infosys is leveraging AI to enhance efficiency, \npersonalization and convenience.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  styleListData: { marginTop: "50px" },
  next: {
    label: "LAUNCH DEMO",
    onClick: () => (window.location.href = Urls.URL_STS as string),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "STS/STS_intro_01.png",
};

export default data;
